/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { Select, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const CustomSelect = withStyles((theme) => ({
  root: {},
}))(Select);
export default function ({
  className,
  placeholder,
  onChange,
  defaultValue,
  id,
  width,
  options,
  value,
  MenuProps,
  noPadding,
}) {
  const style = {
    height: '32px',
    width,
    fontSize: '12px',
  };
  if (!noPadding) {
    style.paddingRight = '12px';
  }
  return (
    <CustomSelect
      variant="outlined"
      style={style}
      MenuProps={MenuProps}
      id={id}
      value={value}
      displayEmpty
      onChange={onChange}
      className={className}
      defaultValue={defaultValue || ''}
      IconComponent={(props) => (
        <a
          style={{ backgroundColor: 'transparent', border: 'none', pointerEvents: 'none' }}
          onClick={() => {}}
        >
          <img alt="Icono de seleccionado" src={props.iconSrc || `${publicPath}/select_up.svg`} />
        </a>
      )}
    >
      {placeholder && (
        <MenuItem style={{ fontSize: '12px' }} value="">
          <span style={{ color: '#838aa2' }}> {placeholder}</span>
        </MenuItem>
      )}
      {options
        ? options.map((elm, i) => (
            <MenuItem style={{ fontSize: '12px' }} key={i} id="menu-item" value={elm.value || i}>
              <span style={{ color: '#444b62' }}>{elm.text}</span>
            </MenuItem>
          ))
        : null}
    </CustomSelect>
  );
}
